module.exports = __webpack_public_path__ + "img/hotel3.a212786c.png";